var exports = {
  "J": "ProfileCardContent.module__contentSection___YTk0bG",
  "s": "ProfileCardContent.module__contentSectionWebhook___YTk0bG",
};

module.exports = exports;
